import React from 'react';
import Double from 'components/home/double';

export default function SectionIconsAndImage({ section }) {
  return <Double section={section} />;
}
